import { ChangeDetectionStrategy, Component, input, output, signal, WritableSignal } from '@angular/core';
import { form, FormField } from '@angular/forms/signals';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  STRIPE_SUBSCRIPTION_STATUSES,
  SubscriptionAdminFilterKey,
  ZoudashUtils,
} from '@workspace/data-types';
import {
  AbstractSignalFormComponent,
  DataHeaderFilter,
  FilterChangedDetection,
  FilterRecord,
} from '@workspace/ng-aura';
import { SubscriptionStatusDisplayPipe } from '@workspace/ng-data-access';
import { SubscriptionColumnKey } from '../abstract-subscriptions-data-table.component';

export interface SubscriptionFilterModel {
  status: string | string[] | null;
}

@Component({
  selector: 'core-subscriptions-data-table-filter',
  templateUrl: './subscriptions-data-table-filter.component.html',
  imports: [
    FormField,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatSlideToggleModule,
    SubscriptionStatusDisplayPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionsDataTableFilterCoreComponent extends AbstractSignalFormComponent<
  Partial<Record<SubscriptionAdminFilterKey, string | string[]>>,
  SubscriptionFilterModel
> {
  filterChanged = output<FilterChangedDetection>();
  currentFilterView = input<string | null>(null);
  filters = input.required<DataHeaderFilter<SubscriptionColumnKey>[]>();
  subscriptionStatusValues = STRIPE_SUBSCRIPTION_STATUSES;
  subscriptionAdminFilterKey = SubscriptionAdminFilterKey;

  override model: WritableSignal<SubscriptionFilterModel> = signal<SubscriptionFilterModel>({
    status: null,
  });

  override formTree = form(this.model);

  override emitDto(newDto: Partial<Record<SubscriptionAdminFilterKey, string | string[]>>): void {
    this.filterChanged.emit({
      filter: newDto as FilterRecord,
      changed: !ZoudashUtils.isEqual(newDto, this.ogValue),
    });
  }

  protected override buildModelFromDto(
    dto: Partial<Record<SubscriptionAdminFilterKey, string | string[]>>,
  ): SubscriptionFilterModel {
    return {
      status: dto?.[SubscriptionAdminFilterKey.Status] ?? null,
    };
  }

  protected override buildDtoFromModel(
    model: SubscriptionFilterModel,
  ): Partial<Record<SubscriptionAdminFilterKey, string | string[]>> {
    const dto: Partial<Record<SubscriptionAdminFilterKey, string | string[]>> = {
      status: model.status ?? undefined,
    };
    return Object.fromEntries(Object.entries(dto).filter(([_, v]) => v != null)) as Partial<
      Record<SubscriptionAdminFilterKey, string | string[]>
    >;
  }
}
